import { render } from "./income_table.vue?vue&type=template&id=2fba4e86&scoped=true"
import script from "./income_table.vue?vue&type=script&lang=js"
export * from "./income_table.vue?vue&type=script&lang=js"

import "./income_table.vue?vue&type=style&index=0&id=2fba4e86&scoped=true&lang=css"

import exportComponent from "/home/chanli/桌面/data_dashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fba4e86"]])

export default __exports__